import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredUserType?: 'internal' | 'partner';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredUserType 
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    if (!authService.isAuthenticated()) {
      navigate('/login');
      return;
    }

    // Check user type if specified
    if (requiredUserType) {
      const userType = authService.getUserType();
      
      if (userType !== requiredUserType) {
        // Redirect to appropriate dashboard based on actual user type
        if (userType === 'partner') {
          navigate('/partner/dashboard');
        } else {
          navigate('/dashboard');
        }
        return;
      }
    }
  }, [navigate, requiredUserType]);

  // If we reach here, user is authenticated and has correct type
  return <>{children}</>;
};

export default ProtectedRoute;